import { render, staticRenderFns } from "./tm-modal.vue?vue&type=template&id=8fa5c6ca&"
import script from "./tm-modal.vue?vue&type=script&lang=ts&"
export * from "./tm-modal.vue?vue&type=script&lang=ts&"
import style0 from "./tm-modal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports